import { selectBlackFridayStatus } from 'components/Header/themes/BGH/selector';
import { useSelector } from 'react-redux';
import { Header } from './header';
import { useNavigation } from './index';
import { NavigationBlock } from 'models/NavigationBlock';
import cn from 'classnames';
import styles from './styles.scss';

export const Panel = ({ items, header }: NavigationBlock) => {
  const { navigationMap } = useNavigation();
  const blackFridayIsActive = useSelector(selectBlackFridayStatus);
  return (
    <div className={cn({ [styles.blackFriday]: blackFridayIsActive })}>
      <Header invert>{header}</Header>
      {items.map(navigationMap)}
    </div>
  );
};
